import { ReplaySubject } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rateRefreshSubject = new ReplaySubject<any>(100, 30000);
